module.exports = __webpack_public_path__ + "img/turbo-features9.5e77c1b6.png";